import primaryComponents from "../../../primaryComponents";
import Validation from "./Validation";
import useSalesAccountSettings from "./useSalesAccountSettings";
import styles from "../../../../pages/appPages/Accounting/AccountSettings/styles.module.scss";

const SalesAccountSettings = ({
  filterAccountBySubAccountType,
  findAccountMapping,
  updateAccountMappingMutation,
  handleAccountMappingSubmit,
}) => {
  const { salesAccountMapping, setSalesAccountMapping } =
    useSalesAccountSettings(findAccountMapping);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = Validation({ salesAccountMapping });
  return (
    <form className="p-3" onSubmit={handleSubmit(handleAccountMappingSubmit)}>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Sales Account</h5>
          <span>
            The primary income account where revenue from sales is recorded
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("sales_revenue")}
            control={control}
            name="sales_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("sales_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                sales_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.sales_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Sales Returns Account</h5>
          <span>Account used to track refunded or returned items</span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("returns_outward")}
            control={control}
            name="sales_return_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("sales_return_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                sales_return_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.sales_return_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Discount Given Account</h5>
          <span>Track redunction given to customers</span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("discount_allowed")}
            control={control}
            name="discount_given_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("discount_given_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                discount_given_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.discount_given_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Cash & Bank Payment Account</h5>
          <span>
            The default asset account is debited when payment is received
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("cash_and_bank")}
            control={control}
            name="cash_bank_payment_method_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("cash_bank_payment_method_account")
                ?.chart_account?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                cash_bank_payment_method_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.cash_bank_payment_method_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Sales Delivery Account</h5>
          <span>
            The default income account is credited when delivery fee is charged
            on sales
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("other_income")}
            control={control}
            name="sales_delivery_fee_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("sales_delivery_fee_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                sales_delivery_fee_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.sales_delivery_fee_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Customer Credit Account</h5>
          <span>
            Default account used to track credit sales when customer is given
            option to pay later
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("accounts_receivable")}
            control={control}
            name="customer_credit_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("customer_credit_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                customer_credit_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.customer_credit_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Store Wallet Account</h5>
          <span>Default account used to track customer(s) store wallets</span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("accounts_payable")}
            control={control}
            name="customer_store_wallet_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("customer_store_wallet_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                customer_store_wallet_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.customer_store_wallet_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Customer Loyalty Account</h5>
          <span>
            Default account used to track customer(s) loyalty and gift card
            given and used
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("accounts_payable")}
            control={control}
            name="customer_loyalty_and_gift_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("customer_loyalty_and_gift_account")
                ?.chart_account?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                customer_loyalty_and_gift_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.customer_loyalty_and_gift_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Other Income Account</h5>
          <span>Default account used to track income from other sources</span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("other_income")}
            control={control}
            name="others_income_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("others_income_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                others_income_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.others_income_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Cash Payment Method Account</h5>
          <span>
            The asset account is debited when payment is received in cash
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("cash_and_bank")}
            control={control}
            name="cash_payment_method_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("cash_payment_method_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                cash_payment_method_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.cash_payment_method_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Card Payment Method Account</h5>
          <span>
            The asset account is debited when payment is received with card
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("cash_and_bank")}
            control={control}
            name="card_payment_method_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("card_payment_method_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                card_payment_method_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.card_payment_method_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Transfer Payment Method Account</h5>
          <span>
            The asset account is debited when payment is received with transfer
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("cash_and_bank")}
            control={control}
            name="transfer_payment_method_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("transfer_payment_method_account")
                ?.chart_account?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setSalesAccountMapping((prev) => ({
                ...prev,
                transfer_payment_method_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.transfer_payment_method_account}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          type="submit"
          isDisabled={updateAccountMappingMutation.isLoading}
          isLoading={updateAccountMappingMutation.isLoading}
          loadingText={"Updating..."}
        >
          Save Changes
        </primaryComponents.Button>
      </div>
    </form>
  );
};
export default SalesAccountSettings;
